import constants from '../constants.json' assert { type: 'json' };


/**
 * Retrieves the latest sort key parameter corresponding to a given legacy sort key.
 *
 * @param {string} legacySortKey - The legacy sort key to be mapped.
 * @returns {string|undefined} The corresponding latest sort key parameter, or undefined if not found.
 */
const getLegacySortKey = (legacySortKey) => {
    const sortKey = constants.LEGACY_SORT_MAP[legacySortKey]?.param;
    return sortKey;
};

export default getLegacySortKey;